import { render, staticRenderFns } from "./GestionServicios.vue?vue&type=template&id=6d150efe&scoped=true"
import script from "./GestionServicios.vue?vue&type=script&lang=js"
export * from "./GestionServicios.vue?vue&type=script&lang=js"
import style0 from "./GestionServicios.vue?vue&type=style&index=0&id=6d150efe&prod&lang=sass"
import style1 from "./GestionServicios.vue?vue&type=style&index=1&id=6d150efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d150efe",
  null
  
)

export default component.exports